import { explytLogo } from "../Common/Icons/Icons";
import { useTranslation } from "react-i18next";
import { List } from "../Common/Elements/List";
import { ExplytStoreItemEntry } from "./ExplytStoreItem";
import { useContext, useEffect, useState } from "react";
import { loading } from "../../communication/wrapped";
import { UserChannel } from "../../types/subscriptions";
import { itemOfType } from "./ExplytStoreItems";
import { LoadingCircle } from "../Common/Loading/LoadingPlaceholder";
import { getChannels } from "../../communication/communication";
import { Button } from "../Common/Elements/Button";
import { SetRootNavigationSelected } from "../Common/Navigation/Navigation";

export function ExplytStore() {
    const { t } = useTranslation();

    const [channels, setChannels] = useState(loading<UserChannel[]>(null!))
    const setNavigation = useContext(SetRootNavigationSelected);

    useEffect(() => {
        getChannels().then(setChannels)
    }, []);

    const goToKeyButton = <Button
        text={t("showApiKey")}
        onClick={() => setNavigation(0)}
        backgroundColor="var(--color-main)"
        textColor="black"
    />

    if (channels.statusCode !== 200) {
        return <div style={{ display: "grid", gridTemplateRows: "1fr 8rem", height: "100%" }}>
            <div className="flex-column small-padding-top small-gap">
                <div className="flex-center">
                    {explytLogo}
                </div>
                <span className="small-margin big-font font-white fw-500"> {t("explytStore")} </span>
                <div className="flex-center small-padding-top"> <LoadingCircle className="loading-circle-big" /> </div>
            </div>
            <div className="small-margin">
                {goToKeyButton}
            </div>
        </div>
    }

    const storeItems = channels.data!.map(c => itemOfType(t, c.channel_id))

    return <div style={{ display: "grid", gridTemplateRows: "1fr 8rem", height: "100%" }}>
        <div className="flex-column small-padding-top small-gap">
            <div className="flex-center">
                {explytLogo}
            </div>
            <span className="small-margin big-font font-white fw-500"> {t("explytStore")} </span>
            <div style={{ height: "calc(var(--app-height) - 18.5rem)" }}>
                <List collection={storeItems}
                    createElement={e => <ExplytStoreItemEntry item={e} />}
                    elementHeight={60}
                    id={"explyt-items"}
                />
            </div>
        </div>
        <div className="small-margin">
            {goToKeyButton}
        </div>
    </div>
}